import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from '@/store';

import { estadoVazio, type EstadoFinanceiroProcesso } from './slice';

const selectState = (state: RootState) => state.financeiroProcessoArbitral;

const ESTADO_VAZIO: EstadoFinanceiroProcesso = estadoVazio();

export const selectFinanceiroDoProcesso = (processoId: string) =>
  createSelector(selectState, (s) => s.byProcessoId[processoId] ?? ESTADO_VAZIO);
